import { render, staticRenderFns } from "./NewBlog.vue?vue&type=template&id=ae6b541e&"
import script from "./NewBlog.vue?vue&type=script&lang=js&"
export * from "./NewBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports